import { render, staticRenderFns } from "./DiscountEdit.vue?vue&type=template&id=60a8316e"
import script from "./DiscountEdit.vue?vue&type=script&lang=js"
export * from "./DiscountEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports